<template>
  <div class="row">
    <div class="col-12 mb-1">
      <CustomInputDisplay
        label="Evaluación:"
        label-class="text-gray font-weight-light"
        :value="source"
        class="font-weight-bold"
      />
    </div>

    <template v-if="isPreviousEvaluation">
      <div class="col-12">
        <CustomInputDisplay
          label="Administrada por:"
          label-class="text-gray font-weight-light"
          :value="administeredBy"
          class="font-weight-bold"
        />
      </div>
    </template>

    <template v-if="isRemProEvaluation">
      <div class="col-12">
        <CustomInputDisplay
          label="Solicitada por:"
          label-class="text-gray font-weight-light"
          :value="requestedBy"
          class="font-weight-bold"
        />
      </div>
    </template>
  </div>
</template>

<script>
import CustomInputDisplay from 'CustomInputDisplay';
import evaluationSourceTypes from '@/utils/constants/student/evaluationSourceTypes';
import moment from 'moment';

export default {
  name: 'GeneralInformation',
  components: {
    CustomInputDisplay,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    model() {
      return this.value;
    },
    isMipeEvaluation() {
      return this.model.sourceId == evaluationSourceTypes.MiPE_Cita;
    },
    isPreviousEvaluation() {
      return this.model.sourceId == evaluationSourceTypes.Previa;
    },
    isRemProEvaluation() {
      return this.model.sourceId == evaluationSourceTypes.Remedio_Provisional;
    },
    source() {
      return this.model?.source || '-';
    },
    administeredBy() {
      return this.model?.administeredBy || '-';
    },
    requestedBy() {
      return this.model?.requestedBy || '-';
    },
    csee() {
      return this.model?.csee || '-';
    },
    municipality() {
      return this.model?.municipality || '-';
    },
    provider() {
      return this.model?.provider || '-';
    },
    serviceLocation() {
      return this.model?.serviceLocation || '-';
    },
    specialist() {
      return this.model?.specialist || '-';
    },
    appointmentNumber() {
      return this.model?.appointmentNumber || '-';
    },
    appointmentDate() {
      if (this.model && this.model.appointmentDate)
        return moment(this.model.appointmentDate).format('DD/MMM/YYYY');

      return '-';
    },
    comment() {
      return this.model?.comment || '-';
    },
  },
};
</script>
